import {Button} from "@mui/material";
import React from "react";
import SendIcon from '@mui/icons-material/Send';
import {useSnackbarAlert} from "../../hooks/useSnackbarAlert";
import {useTranslation} from "react-i18next";
import {sendTestmail} from "../../api/sendTestmailClient";
import {getCustomerTestmailConfig} from "../../api/testmailConfigClient";
import {useParams} from "react-router-dom";
import {useTestmailDialog} from "../../hooks/useTestmailDialog";
import {Language} from "../../model/Language";

interface Props {
    templateId: string
}

export const SendTestmailButton: React.FC<Props> = (props) => {

    const {templateId} = props;
    const [snackbar, openSnackbarAlert] = useSnackbarAlert();
    const {t} = useTranslation();
    let {customerId} = useParams();
    const [testmailDialog, openTestmailDialog] = useTestmailDialog();

    const handleSendTestmail = async (language: Language) => {
        const response = await sendTestmail(templateId, language)
        if (!response.ok)
            openSnackbarAlert(t('templateTable.testmailSentError'), "error");
        else
            openSnackbarAlert(t('templateTable.testmailSentSuccessfully'), "success");
    }

    const openDialog = async (event: React.MouseEvent) => {
        event.stopPropagation()
        const response = await getCustomerTestmailConfig(customerId!)
        const config = await response.json()
        openTestmailDialog(
            t('templateTable.selectLanguage'),
            t('templateTable.testmailConfirm', {mailAddress: config.email}),
            handleSendTestmail
        );
    }

    return (
        <>
            {snackbar}
            {testmailDialog}
            <Button onClick={(event) => openDialog(event)}>
                <SendIcon/>
            </Button>
        </>
    )
}